import { map, pluck } from 'rxjs/operators';
import http from '@/helpers/http';

const mixin = {
  subscriptions() {
    return {
      merchantTagWithSubTags: http({
        method: 'GET',
        url: '/agc-public-api/merchanttags',
      }),
      merchantTagOptions: this.$watchAsObservable('merchantTagWithSubTags').pipe(
        pluck('newValue'),
        map(({ result }) => result.map(({ id, name }) => ({ id, name }))),
      ),
      merchantSubTagOptions: this.$watchAsObservable('merchantTagWithSubTags').pipe(
        pluck('newValue'),
        map(({ result }) => {
          const options = {};
          result.forEach((tag) => {
            options[tag.id] = tag.children;
          });
          return options;
        }),
      ),
    };
  },
};

export default mixin;
